import React from 'react'

const Calculators = () => {
    return (
        <>
            <p>Calculator here</p>
        </>
    )
}

export default Calculators
